export default "__VITE_ASSET__4f1f6c23__"